export const blogData = [
  {
    id: 1,
    title: "AIOps: Integrating Machine Learning into DevOps Workflows",
    description:
      "AIOps, short for Artificial Intelligence for IT Operations, is not just another tech buzzword.",
    date: "Sept 7, 2024",
    image:
      "https://mernstackdev.com/wp-content/uploads/2024/11/Leonardo_Phoenix_A_futuristic_hightech_illustration_of_a_seaml_3_11zon.webp",
    url: "https://mernstackdev.com/aiops-integrating-machine-learning-into-devops-workflows/",
  },
  {
    id: 2,
    title: "Real-Time Applications with WebSockets and Firebase",
    description:
      "WebSockets provide a powerful way to maintain live connections, they come with challenges like managing connections and ensuring reliability.",
    date: "Oct 11, 2024",
    image: "https://mernstackdev.com/wp-content/uploads/2024/10/image-7.png",
    url: "https://mernstackdev.com/full-stack-with-websockets-and-firebase-in-2024/",
  },
  {
    id: 3,
    title: "FastAPI: Building Fast and Efficient APIs",
    description:
      "FastAPI is a modern, fast (high-performance) web framework for building APIs with Python 3.7+ based on standard Python type hints.",
    date: "Aug 14, 2024",
    image:
      "https://mernstackdev.com/wp-content/uploads/2024/11/Leonardo_Phoenix_A_futuristic_hightech_thumbnail_featuring_a_s_1_11zon.webp",
    url: "https://mernstackdev.com/fastapi-building-fast-and-efficient-apis/",
  },
  {
    id: 4,
    title: "Modern API Development with Postman: November 2024 Edition",
    description:
      "The tech world is experiencing a significant transformation with the integration of artificial intelligence into development workflows.",
    date: "Nov 17, 2024",
    image:
      "https://mernstackdev.com/wp-content/uploads/2024/11/Leonardo_Phoenix_A_futuristic_hightech_thumbnail_illustration_2_11zon.webp",
    url: "https://mernstackdev.com/modern-api-development-with-postman-november-2024-edition/",
  },
  {
    id: 5,
    title: "Understanding Triggers in MySQL",
    description:
      "Triggers in MySQL are powerful tools used to automatically execute SQL code when specific changes or events occur within a database.",
    date: "Oct 1, 2024",
    image: "https://mernstackdev.com/understanding-triggers-in-mysql/",
    url: "https://hackzism.blogspot.com/2020/07/how-can-you-get-michaels-or-trevors.html",
  },
];

// Do not remove any fields.
// Leave it blank instead as shown below.

/* 
{
    id: 1,
    title: 'Car Pooling System',
    description: '',
    date: 'Oct 1, 2020',
    image: '',
    url: 'https://preview.colorlib.com/theme/rezume/'
}, 
*/
